export default __webpack_public_path__ + "static/media/spell4.48054eb1.jpg";